import styled from 'styled-components';

export const StyledDeleteAccount = styled.div`
  width: 100%;

  .desc {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    padding: 0 0 20px;

    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 25px;
      padding: 5px 0 30px;
    }
  }
  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
